import { render, staticRenderFns } from "./InformationEmployeeSalary.vue?vue&type=template&id=209484a4&scoped=true"
import script from "./InformationEmployeeSalary.vue?vue&type=script&lang=js"
export * from "./InformationEmployeeSalary.vue?vue&type=script&lang=js"
import style0 from "./InformationEmployeeSalary.vue?vue&type=style&index=0&id=209484a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209484a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209484a4')) {
      api.createRecord('209484a4', component.options)
    } else {
      api.reload('209484a4', component.options)
    }
    module.hot.accept("./InformationEmployeeSalary.vue?vue&type=template&id=209484a4&scoped=true", function () {
      api.rerender('209484a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeSalary/employeeSalarySearchDialog/InformationEmployeeSalary.vue"
export default component.exports